export const getPurchaseDeviceHistory = (pageNumber: number, pageSize: number) => {
	return {
		url: `/wcs/resources/store/10001/order/byStatus/C,I,R,S,K,D,F,G,H,J,K?pageNumber=${pageNumber}&pageSize=${pageSize}&langId=-1`,
		method: 'GET',
	};
};
